function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M499.76,27.994c0,11.877-8.66,21.669-19.99,23.583c1.305,0.227,2.632,0.406,3.998,0.406 c13.252,0,23.988-10.745,23.988-23.989c0-13.251-10.736-23.988-23.988-23.988c-1.366,0-2.693,0.18-3.998,0.406 C491.1,6.317,499.76,16.109,499.76,27.994z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M124.261,451.464c0,11.83-8.637,21.661-19.982,23.582c1.304,0.219,2.624,0.406,3.99,0.406 c13.275,0,23.988-10.792,23.988-23.988c0-13.275-10.713-23.988-23.988-23.988c-1.367,0-2.687,0.18-3.99,0.405 C115.624,429.785,124.261,439.564,124.261,451.464z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M299.856,435.792h7.996c8.878,0,15.992,7.113,15.992,15.992v39.98h-7.996v-39.98 C315.849,442.905,308.734,435.792,299.856,435.792z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M299.856,451.784h7.996c8.878,0,15.992,7.113,15.992,15.992v39.98h-7.996v-39.98 C315.849,458.897,308.734,451.784,299.856,451.784z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M395.803,379.951c8.378-3.03,12.782-5.692,14.719-7.091l1.281-0.078h7.996c15.672,6.154,30.461,11.433,39.98,15.032 c31.984,11.916,47.977,23.988,47.977,55.974c0,31.984,0,63.969,0,63.969h-15.992c0-12.291,0-30.126,0-47.977 c0-31.984-15.992-44.058-47.977-55.974c-9.52-3.6-40.879-14.931-56.551-21.083L395.803,379.951z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M171.918,335.84c0,5.224-3.342,9.612-7.996,11.26c1.257,0.445,2.584,0.734,3.998,0.734c6.637,0,11.995-5.356,11.995-11.994 s-5.357-11.995-11.995-11.995c-1.414,0-2.741,0.289-3.998,0.734C168.575,326.228,171.918,330.615,171.918,335.84z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M347.833,335.84c0,5.224-3.342,9.612-7.996,11.26c1.257,0.445,2.585,0.734,3.998,0.734c6.638,0,11.994-5.356,11.994-11.994 s-5.356-11.995-11.994-11.995c-1.413,0-2.741,0.289-3.998,0.734C344.491,326.228,347.833,330.615,347.833,335.84z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M403.807,439.789c0,5.224-3.343,9.612-7.996,11.26c1.257,0.445,2.584,0.734,3.998,0.734 c6.637,0,11.994-5.357,11.994-11.994c0-6.638-5.357-11.994-11.994-11.994c-1.414,0-2.741,0.288-3.998,0.733 C400.464,430.177,403.807,434.565,403.807,439.789z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M403.807,479.771c0,5.224-3.343,9.612-7.996,11.26c1.257,0.445,2.584,0.734,3.998,0.734 c6.637,0,11.994-5.357,11.994-11.994c0-6.638-5.357-11.994-11.994-11.994c-1.414,0-2.741,0.289-3.998,0.734 C400.464,470.156,403.807,474.546,403.807,479.771z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M491.764,379.818c0-26.55-21.427-47.977-47.977-47.977h-31.984v-15.993h47.977c26.55,0,47.977,21.428,47.977,47.978v79.962 c0-18.445-5.356-30.252-15.992-39.247L491.764,379.818L491.764,379.818z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M395.811,355.829v-39.981v-28.666v-91.276v-31.985v-3.92v-0.078c0-6.395-0.398-12.712-1.203-18.874 C385.65,66.429,323.939,8.238,247.881,4.373c2.663-0.133,5.302-0.375,7.996-0.375c79.72,0,145.454,59.815,154.723,137.051 c0.805,6.161,1.203,12.479,1.203,18.874v0.078v3.92v31.985v119.942v39.981c0,0-3.687,3.646-15.992,8.105L395.811,355.829 L395.811,355.829z"
});

var _ref13 =
/*#__PURE__*/
React.createElement("rect", {
  x: 411.807,
  y: 163.917,
  width: 7.996,
  height: 31.985
});

var _ref14 =
/*#__PURE__*/
React.createElement("rect", {
  x: 91.957,
  y: 163.917,
  width: 7.996,
  height: 31.985
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M395.803,379.951v-16.016c12.306-4.459,16-8.105,16-8.105v15.992c0,0-0.398,0.398-1.281,1.038 C408.585,374.259,404.181,376.921,395.803,379.951z"
});

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var _ref18 =
/*#__PURE__*/
React.createElement("g", null);

var _ref19 =
/*#__PURE__*/
React.createElement("g", null);

var _ref20 =
/*#__PURE__*/
React.createElement("g", null);

var _ref21 =
/*#__PURE__*/
React.createElement("g", null);

var _ref22 =
/*#__PURE__*/
React.createElement("g", null);

var _ref23 =
/*#__PURE__*/
React.createElement("g", null);

var _ref24 =
/*#__PURE__*/
React.createElement("g", null);

var _ref25 =
/*#__PURE__*/
React.createElement("g", null);

var _ref26 =
/*#__PURE__*/
React.createElement("g", null);

var _ref27 =
/*#__PURE__*/
React.createElement("g", null);

var _ref28 =
/*#__PURE__*/
React.createElement("g", null);

var _ref29 =
/*#__PURE__*/
React.createElement("g", null);

var _ref30 =
/*#__PURE__*/
React.createElement("g", null);

var SvgAstronautLiftOff = function SvgAstronautLiftOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.755 511.755",
    style: {
      enableBackground: "new 0 0 511.755 511.755"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("path", {
    style: {
      fill: "#AC92EC"
    },
    d: "M507.756,27.994c0,13.252-10.736,23.989-23.988,23.989c-13.251,0-23.988-10.737-23.988-23.989 c0-13.243,10.737-23.988,23.988-23.988C497.02,4.006,507.756,14.751,507.756,27.994z"
  }), React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M467.775,27.994c0-11.877,8.66-21.669,19.99-23.582c-1.304-0.227-2.631-0.406-3.998-0.406 c-13.251,0-23.988,10.745-23.988,23.988c0,13.252,10.737,23.989,23.988,23.989c1.367,0,2.694-0.18,3.998-0.406 C476.436,49.671,467.775,39.879,467.775,27.994z"
  })), React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _ref2), React.createElement("path", {
    style: {
      fill: "#656D78"
    },
    d: "M483.768,325.212h-31.984c8.824,0,15.992-7.16,15.992-15.992s-7.168-15.992-15.992-15.992H419.8 c8.823,0,15.992-7.161,15.992-15.992c0-8.832-7.169-15.992-15.992-15.992h-47.978c8.824,0,15.992-7.161,15.992-15.993 s-7.168-15.992-15.992-15.992h87.958c8.824,0,15.992-7.16,15.992-15.992s-7.168-15.992-15.992-15.992H419.8 c8.823,0,15.992-7.161,15.992-15.992c0-8.832-7.169-15.993-15.992-15.993h-15.993c8.823,0,15.992-7.161,15.992-15.992 s-7.169-15.993-15.992-15.993h79.961c8.824,0,15.992-7.16,15.992-15.992s-7.168-15.992-15.992-15.992h-31.984 c8.824,0,15.992-7.16,15.992-15.992s-7.168-15.992-15.992-15.992H419.8c8.823,0,15.992-7.161,15.992-15.992 c0-8.832-7.169-15.993-15.992-15.993h-23.988c8.823,0,15.992-7.161,15.992-15.992s-7.169-15.993-15.992-15.993H155.925 c-8.839,0-15.993,7.161-15.993,15.993s7.153,15.992,15.993,15.992H99.952c-8.839,0-15.992,7.161-15.992,15.993 c0,8.831,7.153,15.992,15.992,15.992H83.96c-8.84,0-15.992,7.16-15.992,15.992S75.12,101.32,83.96,101.32h47.977 c-8.839,0-15.992,7.161-15.992,15.992c0,8.832,7.153,15.992,15.992,15.992H43.979c-8.839,0-15.992,7.161-15.992,15.993 s7.153,15.992,15.992,15.992H83.96c-8.84,0-15.992,7.161-15.992,15.993s7.152,15.992,15.992,15.992H43.979 c-8.839,0-15.992,7.16-15.992,15.992s7.153,15.992,15.992,15.992H27.987c-8.839,0-15.993,7.161-15.993,15.992 c0,8.832,7.153,15.993,15.993,15.993h39.981c-8.84,0-15.992,7.16-15.992,15.992c0,8.831,7.152,15.992,15.992,15.992H51.976 c-8.84,0-15.993,7.16-15.993,15.992s7.153,15.992,15.993,15.992h79.961c-8.839,0-15.992,7.16-15.992,15.992 s7.153,15.992,15.992,15.992H99.953c-8.839,0-15.992,7.161-15.992,15.992c0,8.832,7.153,15.992,15.992,15.992h271.869 c8.824,0,15.992-7.16,15.992-15.992c0-8.831-7.168-15.992-15.992-15.992h111.946c8.824,0,15.992-7.16,15.992-15.992 S492.592,325.212,483.768,325.212z"
  }), React.createElement("path", {
    style: {
      fill: "#ED5565"
    },
    d: "M108.269,475.452c-13.275,0-23.988-10.714-23.988-23.988c0-13.197,10.713-23.988,23.988-23.988 c13.197,0,23.988,10.791,23.988,23.988C132.257,464.737,121.465,475.452,108.269,475.452z"
  }), React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M92.276,451.464c0-11.83,8.636-21.662,19.982-23.583c-1.304-0.218-2.624-0.405-3.99-0.405 c-13.275,0-23.988,10.791-23.988,23.988c0,13.274,10.713,23.988,23.988,23.988c1.366,0,2.686-0.18,3.99-0.406 C100.913,473.141,92.276,463.363,92.276,451.464z"
  })), React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _ref3), React.createElement("path", {
    style: {
      fill: "#F6BB42"
    },
    d: "M307.853,451.784h-103.95c-8.879,0-15.992,7.113-15.992,15.992v-15.992 c0-8.879,7.113-15.992,15.992-15.992h103.95c8.878,0,15.992,7.113,15.992,15.992v15.992 C323.845,458.897,316.731,451.784,307.853,451.784z"
  }), React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M211.898,435.792h-7.996c-8.879,0-15.992,7.113-15.992,15.992v39.98h7.996v-39.98 C195.906,442.905,203.02,435.792,211.898,435.792z"
  })), React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _ref4), React.createElement("path", {
    style: {
      fill: "#656D78"
    },
    d: "M399.809,467.776c6.637,0,11.994,5.356,11.994,11.994c0,6.637-5.357,11.994-11.994,11.994 c-6.638,0-11.995-5.357-11.995-11.994S393.171,467.776,399.809,467.776z"
  }), React.createElement("path", {
    style: {
      fill: "#FFCE54"
    },
    d: "M203.902,451.784h103.95c8.878,0,15.992,7.113,15.992,15.992v39.98H187.91v-39.98 C187.91,458.897,195.023,451.784,203.902,451.784z"
  }), React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M211.898,451.784h-7.996c-8.879,0-15.992,7.113-15.992,15.992v39.98h7.996v-39.98 C195.906,458.897,203.02,451.784,211.898,451.784z"
  })), React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _ref5), React.createElement("path", {
    style: {
      fill: "#656D78"
    },
    d: "M411.803,439.789c0,6.637-5.357,11.994-11.994,11.994c-6.638,0-11.995-5.357-11.995-11.994 c0-6.638,5.357-11.994,11.995-11.994C406.445,427.796,411.803,433.151,411.803,439.789z"
  }), React.createElement("path", {
    style: {
      fill: "#CCD1D9"
    },
    d: "M399.809,491.764c6.637,0,11.994-5.357,11.994-11.994c0-6.638-5.357-11.994-11.994-11.994 c-6.638,0-11.995,5.356-11.995,11.994C387.814,486.406,393.171,491.764,399.809,491.764z M399.809,451.784 c6.637,0,11.994-5.357,11.994-11.994c0-6.638-5.357-11.994-11.994-11.994c-6.638,0-11.995,5.356-11.995,11.994 C387.814,446.427,393.171,451.784,399.809,451.784z M51.976,387.815c9.519-3.6,24.309-8.878,39.98-15.032h7.996l1.281,0.078 c3.116,2.241,12.556,7.755,34.702,12.799c11.995,2.718,27.589,5.357,47.978,7.191c13.751,1.281,29.665,2.242,47.977,2.718 c7.598,0.164,15.594,0.242,23.988,0.242c8.395,0,16.391-0.078,23.988-0.242c18.312-0.476,34.227-1.437,47.978-2.718 c20.389-1.834,36.061-4.474,47.977-7.191c23.833-5.442,32.867-11.361,35.265-13.274l0.719,0.397h7.996 c15.672,6.154,30.461,11.433,39.98,15.032c31.984,11.916,47.977,23.988,47.977,55.974c0,31.984,0,63.969,0,63.969H323.845v-39.98 v-15.992c0-8.879-7.114-15.992-15.992-15.992h-103.95c-8.879,0-15.992,7.113-15.992,15.992v15.992v39.98H3.998 c0,0,0-31.984,0-63.969C3.998,411.802,19.991,399.73,51.976,387.815z M132.257,451.464c0-13.197-10.792-23.988-23.988-23.988 c-13.275,0-23.988,10.791-23.988,23.988c0,13.274,10.713,23.988,23.988,23.988C121.465,475.452,132.257,464.737,132.257,451.464z"
  }), React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M115.952,379.951c-8.379-3.03-12.783-5.692-14.719-7.091l-1.281-0.078h-7.996 c-15.672,6.154-30.462,11.433-39.98,15.032C19.991,399.73,3.998,411.802,3.998,443.788c0,31.984,0,63.969,0,63.969h15.993 c0-12.291,0-30.126,0-47.977c0-31.984,15.992-44.058,47.977-55.974c9.519-3.6,40.879-14.931,56.551-21.083L115.952,379.951z"
  })), React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _ref6), React.createElement("path", {
    style: {
      fill: "#656D78"
    },
    d: "M375.819,369.667c-11.916,2.718-27.588,5.357-47.977,7.191c-13.751,1.281-29.665,2.242-47.978,2.718 c-7.598,0.164-15.594,0.242-23.988,0.242c-8.394,0-16.391-0.078-23.988-0.242c-18.312-0.476-34.226-1.437-47.977-2.718 c-20.389-1.834-35.983-4.474-47.978-7.191c-28.705-6.56-35.982-13.837-35.982-13.837v15.992c0,0,0.398,0.398,1.281,1.038 c3.116,2.241,12.556,7.755,34.702,12.799c11.995,2.718,27.589,5.357,47.978,7.191c13.751,1.281,29.665,2.242,47.977,2.718 c7.598,0.164,15.594,0.242,23.988,0.242c8.395,0,16.391-0.078,23.988-0.242c18.312-0.476,34.227-1.437,47.978-2.718 c20.389-1.834,36.061-4.474,47.977-7.191c23.833-5.442,32.867-11.361,35.265-13.274c0.477-0.32,0.719-0.562,0.719-0.562v-15.992 C411.803,355.829,404.524,363.107,375.819,369.667z"
  }), React.createElement("path", {
    style: {
      fill: "#ED5565"
    },
    d: "M167.919,323.845c6.637,0,11.995,5.357,11.995,11.995s-5.357,11.994-11.995,11.994 s-11.994-5.356-11.994-11.994S161.282,323.845,167.919,323.845z"
  }), React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M163.921,335.84c0-5.225,3.342-9.612,7.996-11.261c-1.257-0.445-2.584-0.734-3.998-0.734 c-6.637,0-11.994,5.357-11.994,11.995s5.357,11.994,11.994,11.994c1.414,0,2.741-0.289,3.998-0.734 C167.264,345.452,163.921,341.064,163.921,335.84z"
  })), React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _ref7), React.createElement("path", {
    style: {
      fill: "#ED5565"
    },
    d: "M343.835,323.845c6.638,0,11.994,5.357,11.994,11.995s-5.356,11.994-11.994,11.994 s-11.994-5.356-11.994-11.994S337.197,323.845,343.835,323.845z"
  }), React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M339.837,335.84c0-5.225,3.342-9.612,7.996-11.261c-1.257-0.445-2.585-0.734-3.998-0.734 c-6.638,0-11.994,5.357-11.994,11.995s5.356,11.994,11.994,11.994c1.413,0,2.741-0.289,3.998-0.734 C343.179,345.452,339.837,341.064,339.837,335.84z"
  })), React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _ref8), React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M395.811,439.789c0-5.225,3.342-9.613,7.996-11.261c-1.258-0.445-2.585-0.733-3.998-0.733 c-6.638,0-11.995,5.356-11.995,11.994c0,6.637,5.357,11.994,11.995,11.994c1.413,0,2.74-0.289,3.998-0.734 C399.152,449.401,395.811,445.013,395.811,439.789z"
  })), React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _ref9), React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M395.811,479.771c0-5.225,3.342-9.613,7.996-11.26c-1.258-0.445-2.585-0.734-3.998-0.734 c-6.638,0-11.995,5.356-11.995,11.994c0,6.637,5.357,11.994,11.995,11.994c1.413,0,2.74-0.289,3.998-0.734 C399.152,489.383,395.811,484.993,395.811,479.771z"
  })), React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _ref10), React.createElement("path", {
    style: {
      fill: "#E6E9ED"
    },
    d: "M410.6,141.049C401.331,63.813,335.597,3.998,255.877,3.998 c-79.719,0-145.453,59.815-154.722,137.051c-0.804,6.161-1.203,12.479-1.203,18.874v0.078v3.92v31.985v119.942v39.981 c0,0,7.278,7.277,35.982,13.837c11.995,2.718,27.589,5.357,47.978,7.191c13.751,1.281,29.665,2.242,47.977,2.718 c7.598,0.164,15.594,0.242,23.988,0.242c8.395,0,16.391-0.078,23.988-0.242c18.312-0.476,34.227-1.437,47.978-2.718 c20.389-1.834,36.061-4.474,47.977-7.191c28.705-6.56,35.983-13.837,35.983-13.837v-39.981V195.906v-31.985v-3.92v-0.078 C411.803,153.528,411.404,147.21,410.6,141.049z M167.919,347.833c-6.637,0-11.994-5.356-11.994-11.994s5.357-11.995,11.994-11.995 s11.995,5.357,11.995,11.995S174.557,347.833,167.919,347.833z M343.835,347.833c-6.638,0-11.994-5.356-11.994-11.994 s5.356-11.995,11.994-11.995s11.994,5.357,11.994,11.995S350.473,347.833,343.835,347.833z M387.814,259.875 c0,22.067-17.913,39.98-39.98,39.98H235.887h-71.965c-22.067,0-39.981-17.913-39.981-39.98V147.929c0-1.358,0.078-2.717,0.242-4.076 c1.999-20.154,19.03-35.904,39.739-35.904h119.942h63.97c20.709,0,37.739,15.75,39.739,35.904c0.164,1.359,0.241,2.718,0.241,4.076 L387.814,259.875L387.814,259.875z"
  }), React.createElement("path", {
    style: {
      fill: "#5D9CEC"
    },
    d: "M387.572,143.853c-2-20.154-19.03-35.904-39.739-35.904h-63.97H163.921 c-20.708,0-37.74,15.75-39.739,35.904c-0.164,1.359-0.242,2.718-0.242,4.076v111.946c0,22.067,17.914,39.98,39.981,39.98h71.965 h111.946c22.067,0,39.98-17.913,39.98-39.98V147.929C387.814,146.57,387.736,145.211,387.572,143.853z"
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#ED5565"
    },
    d: "M507.756,363.826v79.962c0-31.985-15.992-44.058-47.977-55.974c-9.52-3.6-24.309-8.878-39.98-15.032 h-7.996h-1.281c0.242-0.164,0.398-0.319,0.562-0.397c0.477-0.32,0.719-0.562,0.719-0.562V355.83v-39.981h47.977 C486.329,315.849,507.756,337.276,507.756,363.826z"
  }), React.createElement("path", {
    style: {
      fill: "#ED5565"
    },
    d: "M91.956,372.781c-15.672,6.154-30.462,11.433-39.98,15.032 C19.991,399.73,3.998,411.802,3.998,443.788v-79.962c0-26.55,21.428-47.978,47.978-47.978h47.977v39.981v15.992 c0,0,0.398,0.398,1.281,1.038l-1.281-0.078h-7.997V372.781z"
  })), React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M19.991,379.818c0-26.55,21.427-47.977,47.977-47.977h31.984v-15.993H51.976 c-26.55,0-47.978,21.428-47.978,47.978v79.962c0-18.445,5.357-30.252,15.993-39.247C19.991,404.54,19.991,379.818,19.991,379.818z"
  })), React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _ref11), React.createElement("path", {
    style: {
      fill: "#656D78"
    },
    d: "M331.841,276.189c0,4.396-5.356,7.996-11.994,7.996s-11.994-3.6-11.994-7.996 s5.356-7.996,11.994-7.996S331.841,271.792,331.841,276.189z"
  }), React.createElement("g", null, React.createElement("rect", {
    x: 83.957,
    y: 163.917,
    style: {
      fill: "#CCD1D9"
    },
    width: 15.992,
    height: 31.985
  }), React.createElement("rect", {
    x: 411.807,
    y: 163.917,
    style: {
      fill: "#CCD1D9"
    },
    width: 15.992,
    height: 31.985
  })), React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "283.863,107.948 246.366,107.948 194.945,299.857 235.887,299.857 236.34,299.857  287.76,107.948  "
  })), React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "252.895,299.857 304.315,107.948 296.045,107.948 244.617,299.857  "
  })), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M115.944,355.829v-39.981v-28.666v-91.276v-31.985v-3.92v-0.078c0-6.395,0.398-12.712,1.203-18.874 c8.957-74.62,70.669-132.811,146.726-136.676c-2.662-0.133-5.302-0.375-7.996-0.375c-79.719,0-145.453,59.815-154.722,137.051 c-0.804,6.161-1.203,12.479-1.203,18.874v0.078v3.92v31.985v119.942v39.981c0,0,3.686,3.646,15.992,8.105 C115.944,363.935,115.944,355.829,115.944,355.829z"
  }), React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _ref12), React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _ref13), React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _ref14), React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M115.952,379.951v-16.016c-12.307-4.459-16-8.105-16-8.105v15.992c0,0,0.398,0.398,1.281,1.038 C103.169,374.259,107.573,376.921,115.952,379.951z"
  })), React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _ref15), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M507.756,511.755H3.998c-2.21,0-3.998-1.788-3.998-3.998v-63.969 c0-34.312,17.773-47.462,50.577-59.722l8.621-3.194c8.793-3.24,19.787-7.301,31.306-11.791c2.062-0.796,4.38,0.219,5.177,2.272 c0.805,2.054-0.211,4.373-2.272,5.178c-11.564,4.513-22.614,8.589-31.445,11.846l-8.59,3.186 C22.63,403.049,7.996,413.802,7.996,443.788v59.971h495.762v-59.971c0-29.986-14.633-40.738-45.377-52.226l-8.503-3.154 c-8.848-3.265-19.929-7.356-31.524-11.877c-2.054-0.805-3.076-3.124-2.271-5.178c0.804-2.054,3.115-3.076,5.177-2.272 c11.549,4.498,22.583,8.574,31.384,11.822l8.534,3.163c32.805,12.26,50.577,25.409,50.577,59.722v63.969 C511.754,509.966,509.966,511.755,507.756,511.755z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M20.232,23.988c-2.21,0-4.037-1.788-4.037-3.998s1.75-3.998,3.951-3.998h0.086 c2.202,0,3.998,1.788,3.998,3.998S22.435,23.988,20.232,23.988z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M60.213,87.958c-2.209,0-4.037-1.789-4.037-3.998c0-2.21,1.75-3.999,3.952-3.999h0.085 c2.202,0,3.998,1.789,3.998,3.999C64.211,86.169,62.416,87.958,60.213,87.958z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M492.357,263.874c-2.21,0-4.037-1.788-4.037-3.998s1.749-3.998,3.951-3.998h0.086 c2.202,0,3.998,1.788,3.998,3.998S494.56,263.874,492.357,263.874z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M468.018,143.931c-2.21,0-4.037-1.788-4.037-3.998s1.749-3.998,3.951-3.998h0.086 c2.202,0,3.998,1.788,3.998,3.998S470.22,143.931,468.018,143.931z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M380.06,9.37c-2.21,0-4.037-1.788-4.037-3.998c0-2.209,1.749-3.998,3.951-3.998h0.086 c2.202,0,3.998,1.789,3.998,3.998C384.058,7.582,382.262,9.37,380.06,9.37z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M4.24,167.919c-2.21,0-4.037-1.788-4.037-3.998c0-2.209,1.749-3.998,3.951-3.998H4.24 c2.202,0,3.998,1.789,3.998,3.998C8.238,166.131,6.442,167.919,4.24,167.919z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M35.983,271.87c-2.21,0-3.998-1.788-3.998-3.998v-31.984c0-2.21,1.788-3.998,3.998-3.998 s3.998,1.788,3.998,3.998v31.984C39.981,270.082,38.193,271.87,35.983,271.87z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M43.979,255.877H27.987c-2.21,0-3.998-1.788-3.998-3.998s1.788-3.998,3.998-3.998h15.992 c2.21,0,3.998,1.788,3.998,3.998S46.189,255.877,43.979,255.877z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M483.768,55.973c-7.473,0-14.501-2.913-19.787-8.199c-5.287-5.287-8.199-12.314-8.199-19.788 c0-7.473,2.912-14.501,8.199-19.787c10.573-10.573,29.002-10.573,39.574,0c5.287,5.286,8.199,12.314,8.199,19.787 s-2.912,14.501-8.199,19.788C498.269,53.061,491.24,55.973,483.768,55.973z M483.768,7.996c-5.333,0-10.354,2.077-14.134,5.856 s-5.856,8.801-5.856,14.134s2.077,10.354,5.856,14.134c7.559,7.559,20.709,7.559,28.268,0c3.779-3.779,5.856-8.8,5.856-14.134 c0-5.333-2.077-10.354-5.856-14.134S489.102,7.996,483.768,7.996z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M463.113,55.271c-1.858,0-3.498-0.555-4.786-1.843c-1.562-1.562-1.562-4.092,0-5.654 c1.39-1.382,3.537-1.539,5.091-0.468c2.569-0.148,11.658-4.975,23.177-16.492c11.518-11.518,16.344-20.607,16.491-23.177 c-1.069-1.554-0.921-3.709,0.469-5.091c1.562-1.562,4.092-1.562,5.654,0c8.074,8.074-12.713,29.673-16.961,33.921 C488.68,40.035,472.867,55.271,463.113,55.271z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M411.803,163.921c-2.21,0-3.998-1.788-3.998-3.998c0-83.772-68.156-151.927-151.928-151.927 S103.95,76.151,103.95,159.923c0,2.21-1.788,3.998-3.998,3.998s-3.998-1.788-3.998-3.998C95.954,71.739,167.693,0,255.877,0 c88.185,0,159.924,71.739,159.924,159.923C415.801,162.133,414.012,163.921,411.803,163.921z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M411.803,351.832c-2.21,0-3.998-1.788-3.998-3.998V160.048c0-2.21,1.788-3.998,3.998-3.998 c2.209,0,3.998,1.788,3.998,3.998v187.785C415.801,350.043,414.012,351.832,411.803,351.832z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M99.952,351.832c-2.21,0-3.998-1.788-3.998-3.998V160.048c0-2.21,1.788-3.998,3.998-3.998 s3.998,1.788,3.998,3.998v187.785C103.95,350.043,102.162,351.832,99.952,351.832z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M347.833,303.854H163.921c-2.209,0-3.998-1.788-3.998-3.998c0-2.209,1.789-3.998,3.998-3.998 h183.912c2.21,0,3.998,1.789,3.998,3.998C351.831,302.065,350.043,303.854,347.833,303.854z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M123.94,151.927c-2.21,0-3.998-1.788-3.998-3.998c0-24.246,19.733-43.979,43.979-43.979 c2.21,0,3.998,1.788,3.998,3.998s-1.788,3.998-3.998,3.998c-19.842,0-35.983,16.141-35.983,35.982 C127.939,150.139,126.15,151.927,123.94,151.927z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M387.814,151.927c-2.21,0-3.998-1.788-3.998-3.998c0-19.842-16.141-35.982-35.982-35.982 c-2.21,0-3.998-1.788-3.998-3.998s1.788-3.998,3.998-3.998c24.246,0,43.979,19.732,43.979,43.979 C391.813,150.139,390.023,151.927,387.814,151.927z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M347.833,111.946H163.921c-2.209,0-3.998-1.788-3.998-3.998s1.789-3.998,3.998-3.998h183.912 c2.21,0,3.998,1.788,3.998,3.998S350.043,111.946,347.833,111.946z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M347.833,303.854c-2.21,0-3.998-1.788-3.998-3.998c0-2.209,1.788-3.998,3.998-3.998 c19.842,0,35.982-16.141,35.982-35.982c0-2.21,1.788-3.998,3.998-3.998s3.999,1.788,3.999,3.998 C391.813,284.121,372.079,303.854,347.833,303.854z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M163.921,303.854c-24.246,0-43.979-19.732-43.979-43.979c0-2.21,1.788-3.998,3.998-3.998 s3.998,1.788,3.998,3.998c0,19.842,16.141,35.982,35.983,35.982c2.21,0,3.998,1.789,3.998,3.998 C167.919,302.065,166.131,303.854,163.921,303.854z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M123.94,263.874c-2.21,0-3.998-1.788-3.998-3.998V147.929c0-2.21,1.788-3.998,3.998-3.998 s3.998,1.788,3.998,3.998v111.946C127.939,262.086,126.15,263.874,123.94,263.874z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M387.814,263.874c-2.21,0-3.998-1.788-3.998-3.998V147.929c0-2.21,1.788-3.998,3.998-3.998 s3.999,1.788,3.999,3.998v111.946C391.813,262.086,390.023,263.874,387.814,263.874z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M255.877,383.815c-132.077,0-157.721-24.129-158.751-25.159c-1.562-1.562-1.562-4.092,0-5.654 c1.554-1.538,4.053-1.554,5.607-0.047c0.492,0.438,26.627,22.864,153.145,22.864c127.119,0,152.903-22.638,153.153-22.864 c1.585-1.491,4.115-1.46,5.622,0.125c1.516,1.562,1.516,4.037-0.023,5.576C413.599,359.688,387.954,383.815,255.877,383.815z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M255.877,399.809c-132.077,0-157.721-24.129-158.751-25.159c-1.562-1.562-1.562-4.092,0-5.654 c1.554-1.538,4.053-1.562,5.607-0.047c0.492,0.438,26.627,22.864,153.145,22.864c127.119,0,152.903-22.638,153.153-22.864 c1.585-1.491,4.115-1.46,5.622,0.125c1.516,1.562,1.516,4.037-0.023,5.576C413.599,375.68,387.954,399.809,255.877,399.809z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M427.795,167.919h-7.333c-2.21,0-3.998-1.788-3.998-3.998c0-2.209,1.788-3.998,3.998-3.998h7.333 c2.209,0,3.998,1.789,3.998,3.998C431.793,166.131,430.004,167.919,427.795,167.919z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M427.795,199.904c-2.21,0-3.998-1.788-3.998-3.998v-31.985c0-2.209,1.788-3.998,3.998-3.998 c2.209,0,3.998,1.789,3.998,3.998v31.985C431.793,198.116,430.004,199.904,427.795,199.904z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M427.795,199.904h-7.996c-2.21,0-3.998-1.788-3.998-3.998c0-2.209,1.788-3.998,3.998-3.998h7.996 c2.209,0,3.998,1.789,3.998,3.998C431.793,198.116,430.004,199.904,427.795,199.904z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M91.292,199.904H83.96c-2.21,0-3.998-1.788-3.998-3.998c0-2.209,1.788-3.998,3.998-3.998h7.332 c2.21,0,3.998,1.789,3.998,3.998C95.29,198.116,93.502,199.904,91.292,199.904z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M83.96,199.904c-2.21,0-3.998-1.788-3.998-3.998v-31.985c0-2.209,1.788-3.998,3.998-3.998 s3.998,1.789,3.998,3.998v31.985C87.958,198.116,86.17,199.904,83.96,199.904z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M91.956,167.919H83.96c-2.21,0-3.998-1.788-3.998-3.998c0-2.209,1.788-3.998,3.998-3.998h7.996 c2.21,0,3.998,1.789,3.998,3.998C95.954,166.131,94.166,167.919,91.956,167.919z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M99.952,375.819c-2.21,0-3.998-1.788-3.998-3.998v-15.992c0-2.21,1.788-3.998,3.998-3.998 s3.998,1.788,3.998,3.998v15.992C103.95,374.031,102.162,375.819,99.952,375.819z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M411.803,375.819c-2.21,0-3.998-1.788-3.998-3.998v-15.992c0-2.21,1.788-3.998,3.998-3.998 c2.209,0,3.998,1.788,3.998,3.998v15.992C415.801,374.031,414.012,375.819,411.803,375.819z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M135.935,389.664c-2.209,0-3.998-1.788-3.998-3.998v-15.992c0-2.21,1.789-3.998,3.998-3.998 c2.21,0,3.998,1.788,3.998,3.998v15.992C139.933,387.876,138.145,389.664,135.935,389.664z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M183.912,396.786c-2.21,0-3.998-1.788-3.998-3.998v-15.915c0-2.209,1.788-3.998,3.998-3.998 c2.209,0,3.998,1.789,3.998,3.998v15.915C187.91,394.999,186.122,396.786,183.912,396.786z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M231.889,399.526c-2.21,0-3.998-1.788-3.998-3.998v-15.711c0-2.21,1.788-3.998,3.998-3.998 s3.998,1.788,3.998,3.998v15.711C235.887,397.738,234.099,399.526,231.889,399.526z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M279.865,399.526c-2.209,0-3.998-1.788-3.998-3.998v-15.992c0-2.21,1.789-3.998,3.998-3.998 c2.211,0,3.998,1.788,3.998,3.998v15.992C283.863,397.738,282.076,399.526,279.865,399.526z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M327.843,396.786c-2.21,0-3.998-1.788-3.998-3.998v-15.915c0-2.209,1.788-3.998,3.998-3.998 s3.998,1.789,3.998,3.998v15.915C331.841,394.999,330.053,396.786,327.843,396.786z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M375.819,389.656c-2.21,0-3.998-1.788-3.998-3.998v-15.984c0-2.21,1.788-3.998,3.998-3.998 s3.998,1.788,3.998,3.998v15.984C379.817,387.868,378.029,389.656,375.819,389.656z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M331.841,279.866c-2.21,0-3.998-1.788-3.998-3.998s1.788-3.998,3.998-3.998 c19.842,0,35.982-16.141,35.982-35.982c0-2.21,1.788-3.998,3.998-3.998s3.998,1.788,3.998,3.998 C375.819,260.134,356.087,279.866,331.841,279.866z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M319.847,287.862c-8.965,0-15.992-5.271-15.992-11.994s7.027-11.994,15.992-11.994 c8.964,0,15.992,5.271,15.992,11.994C335.839,282.591,328.811,287.862,319.847,287.862z M319.847,271.87 c-4.881,0-7.996,2.366-7.996,3.998c0,1.633,3.115,3.998,7.996,3.998c4.88,0,7.996-2.365,7.996-3.998 C327.843,274.236,324.727,271.87,319.847,271.87z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M235.887,351.832c-2.21,0-3.998-1.788-3.998-3.998v-15.992c0-2.21,1.788-3.999,3.998-3.999 s3.998,1.789,3.998,3.999v15.992C239.885,350.043,238.097,351.832,235.887,351.832z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M255.877,359.828c-2.21,0-3.998-1.788-3.998-3.998v-31.985c0-2.209,1.788-3.998,3.998-3.998 c2.21,0,3.998,1.789,3.998,3.998v31.985C259.875,358.039,258.087,359.828,255.877,359.828z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M275.867,351.832c-2.209,0-3.998-1.788-3.998-3.998v-15.992c0-2.21,1.789-3.999,3.998-3.999 c2.21,0,3.998,1.789,3.998,3.999v15.992C279.865,350.043,278.077,351.832,275.867,351.832z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M343.835,351.832c-8.816,0-15.992-7.177-15.992-15.992c0-8.816,7.176-15.993,15.992-15.993 s15.992,7.177,15.992,15.993C359.827,344.655,352.651,351.832,343.835,351.832z M343.835,327.842c-4.412,0-7.996,3.585-7.996,7.997 c0,4.411,3.584,7.996,7.996,7.996s7.996-3.585,7.996-7.996C351.831,331.427,348.247,327.842,343.835,327.842z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M167.919,351.832c-8.816,0-15.992-7.177-15.992-15.992c0-8.816,7.176-15.993,15.992-15.993 s15.993,7.177,15.993,15.993C183.912,344.655,176.735,351.832,167.919,351.832z M167.919,327.842c-4.412,0-7.996,3.585-7.996,7.997 c0,4.411,3.584,7.996,7.996,7.996s7.997-3.585,7.997-7.996C175.916,331.427,172.332,327.842,167.919,327.842z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M108.23,479.488c-15.43,0-27.986-12.557-27.986-27.986c0-15.431,12.556-27.986,27.986-27.986 s27.986,12.556,27.986,27.986C136.216,466.932,123.659,479.488,108.23,479.488z M108.23,431.513c-11.026,0-19.99,8.964-19.99,19.99 c0,11.025,8.964,19.99,19.99,19.99s19.99-8.965,19.99-19.99C128.22,440.477,119.255,431.513,108.23,431.513z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M97.953,452.073c-1.288,0-2.554-0.625-3.326-1.781c-1.227-1.835-0.727-4.318,1.108-5.544 l20.553-13.704c1.819-1.227,4.311-0.742,5.544,1.108c1.227,1.835,0.727,4.318-1.108,5.544L100.171,451.4 C99.491,451.854,98.719,452.073,97.953,452.073z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M118.506,458.928c-0.422,0-0.844-0.062-1.265-0.203l-20.552-6.855 c-2.093-0.703-3.226-2.968-2.53-5.061c0.71-2.093,2.983-3.225,5.06-2.53l20.552,6.856c2.093,0.703,3.226,2.967,2.53,5.061 C121.738,457.866,120.177,458.928,118.506,458.928z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M97.953,472.633c-1.288,0-2.554-0.624-3.326-1.78c-1.227-1.835-0.727-4.318,1.108-5.544 l20.553-13.704c1.819-1.219,4.311-0.734,5.544,1.108c1.227,1.835,0.727,4.318-1.108,5.544l-20.553,13.705 C99.491,472.414,98.719,472.633,97.953,472.633z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M399.809,455.781c-8.816,0-15.993-7.177-15.993-15.992c0-8.816,7.177-15.992,15.993-15.992 c8.815,0,15.992,7.176,15.992,15.992S408.624,455.781,399.809,455.781z M399.809,431.793c-4.412,0-7.996,3.584-7.996,7.996 c0,4.411,3.584,7.996,7.996,7.996c4.411,0,7.996-3.585,7.996-7.996C407.805,435.378,404.22,431.793,399.809,431.793z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M399.809,495.763c-8.816,0-15.993-7.176-15.993-15.992s7.177-15.992,15.993-15.992 c8.815,0,15.992,7.176,15.992,15.992S408.624,495.763,399.809,495.763z M399.809,471.773c-4.412,0-7.996,3.584-7.996,7.996 s3.584,7.996,7.996,7.996c4.411,0,7.996-3.584,7.996-7.996S404.22,471.773,399.809,471.773z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M187.91,471.773c-2.21,0-3.998-1.788-3.998-3.998c0-11.026,8.964-19.99,19.99-19.99 c2.21,0,3.998,1.788,3.998,3.998c0,2.209-1.788,3.998-3.998,3.998c-6.614,0-11.994,5.38-11.994,11.994 C191.908,469.986,190.12,471.773,187.91,471.773z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M323.845,471.773c-2.21,0-3.998-1.788-3.998-3.998c0-6.614-5.38-11.994-11.994-11.994 c-2.21,0-3.998-1.789-3.998-3.998c0-2.21,1.788-3.998,3.998-3.998c11.025,0,19.99,8.964,19.99,19.99 C327.843,469.986,326.055,471.773,323.845,471.773z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M187.91,511.755c-2.21,0-3.998-1.788-3.998-3.998v-39.98c0-2.21,1.788-3.998,3.998-3.998 s3.998,1.788,3.998,3.998v39.98C191.908,509.966,190.12,511.755,187.91,511.755z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M323.845,511.755c-2.21,0-3.998-1.788-3.998-3.998v-39.98c0-2.21,1.788-3.998,3.998-3.998 s3.998,1.788,3.998,3.998v39.98C327.843,509.966,326.055,511.755,323.845,511.755z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M307.853,455.781h-103.95c-2.21,0-3.998-1.789-3.998-3.998c0-2.21,1.788-3.998,3.998-3.998h103.95 c2.21,0,3.998,1.788,3.998,3.998C311.851,453.992,310.063,455.781,307.853,455.781z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M187.91,455.781c-2.21,0-3.998-1.789-3.998-3.998c0-11.026,8.964-19.99,19.99-19.99 c2.21,0,3.998,1.787,3.998,3.998c0,2.209-1.788,3.998-3.998,3.998c-6.614,0-11.994,5.38-11.994,11.994 C191.908,453.992,190.12,455.781,187.91,455.781z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M323.845,455.781c-2.21,0-3.998-1.789-3.998-3.998c0-6.614-5.38-11.994-11.994-11.994 c-2.21,0-3.998-1.789-3.998-3.998c0-2.211,1.788-3.998,3.998-3.998c11.025,0,19.99,8.964,19.99,19.99 C327.843,453.992,326.055,455.781,323.845,455.781z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M307.853,439.789h-103.95c-2.21,0-3.998-1.789-3.998-3.998c0-2.211,1.788-3.998,3.998-3.998h103.95 c2.21,0,3.998,1.787,3.998,3.998C311.851,438,310.063,439.789,307.853,439.789z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M299.856,479.771h-87.958c-2.21,0-3.998-1.788-3.998-3.998s1.788-3.998,3.998-3.998h87.958 c2.21,0,3.998,1.788,3.998,3.998S302.066,479.771,299.856,479.771z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M299.856,495.763h-87.958c-2.21,0-3.998-1.788-3.998-3.998s1.788-3.998,3.998-3.998h87.958 c2.21,0,3.998,1.788,3.998,3.998S302.066,495.763,299.856,495.763z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M3.998,367.824c-2.21,0-3.998-1.788-3.998-3.998c0-28.658,23.317-51.976,51.976-51.976 c2.209,0,3.998,1.789,3.998,3.998c0,2.211-1.789,3.998-3.998,3.998c-24.247,0-43.979,19.733-43.979,43.979 C7.996,366.035,6.208,367.824,3.998,367.824z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M83.96,319.846H51.976c-2.21,0-3.999-1.787-3.999-3.998c0-2.209,1.789-3.998,3.999-3.998H83.96 c2.21,0,3.998,1.789,3.998,3.998C87.958,318.06,86.17,319.846,83.96,319.846z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M3.998,407.805c-2.21,0-3.998-1.788-3.998-3.998v-39.98c0-2.21,1.788-3.998,3.998-3.998 s3.998,1.788,3.998,3.998v39.98C7.996,406.017,6.208,407.805,3.998,407.805z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M507.756,367.824c-2.209,0-3.998-1.788-3.998-3.998c0-24.246-19.732-43.979-43.979-43.979 c-2.21,0-3.998-1.787-3.998-3.998c0-2.209,1.788-3.998,3.998-3.998c28.658,0,51.975,23.317,51.975,51.976 C511.754,366.035,509.966,367.824,507.756,367.824z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M459.779,319.846h-31.984c-2.21,0-3.998-1.787-3.998-3.998c0-2.209,1.788-3.998,3.998-3.998h31.984 c2.21,0,3.998,1.789,3.998,3.998C463.777,318.06,461.989,319.846,459.779,319.846z"
  }), React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M507.756,407.805c-2.209,0-3.998-1.788-3.998-3.998v-39.98c0-2.21,1.789-3.998,3.998-3.998 c2.21,0,3.998,1.788,3.998,3.998v39.98C511.754,406.017,509.966,407.805,507.756,407.805z"
  })), _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAstronautLiftOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/astronautLiftOff.39807ea1.svg";
export { ForwardRef as ReactComponent };